import { buryPoint } from '@/Common/plugins/buried-point';

export default {
  accountAuthentication(index) {
    const result = {
      0: '认证通过',
      1: '认证码无效'
    };

    buryPoint.event({
      action: '账号认证-认证结果',
      eventCategory: '账号认证',
      eventLabel: result[index]
    });
  },
  adminRegister(index) {
    const op = {
      1: '认证码必填',
      2: '认证码选填',
      3: '不需要验证码'
    };
    buryPoint.event({
      action: 'admin用户注册-使用功能',
      eventCategory: 'admin用户注册',
      eventLabel: op[index]
    });
  },
  visitAdminRegister(index) {
    const op = {
      1: '认证码必填',
      2: '认证码选填',
      3: '不需要验证码'
    };
    buryPoint.event({
      action: 'admin用户注册-admin注册访问',
      eventCategory: 'admin用户注册',
      eventLabel: op[index]
    });
  },
  adminRegisterResult(index) {
    const result = {
      0: '注册成功',
      // 1: '注册失败，邮箱地址已注册',
      // 2: '认证码错误',
      // 3: '其他'
      1: '注册失败，邮箱已存在',
      2: '注册失败，邮件验证码错误',
      3: '注册失败，邮件验证码过期',
      4: '注册失败，邮件验证码尝试超过最大次数',
      5: 'B账户池已空',
      6: 'IP代表国家与认证码代表国家不一致',
      7: '其他'
    };

    buryPoint.event({
      action: 'admin用户注册-注册结果',
      eventCategory: 'admin用户注册',
      eventLabel: result[index]
    });
  },
  resendActiveEmail() {
    buryPoint.event({
      action: 'admin用户注册-重新发送激活邮件',
      eventCategory: 'admin用户注册'
    });
  },
  resendModelShow() {
    buryPoint.event({
      action: 'admin用户注册-未激活账号登录',
      eventCategory: 'admin用户注册'
    });
  },
  oneHikIDLogin(type, typeEvent) {
    const op = {
      1: 'OneHikID登录',
      2: 'OneHikID登录成功',
      3: 'HPC登录结果'
    };
    const opEvent = {
      1: {
        1: '新首页页面中间OneHikId登录按钮',
        // 2: '右上角登录下拉选项',
        3: 'HPC登录弹窗底部-“Onehikid登录”'
      },
      3: {
        1: '成功',
        2: '失败'
      }
    };
    buryPoint.event({
      eventCategory: 'OneHikID登录',
      action: `OneHikID登录-${op[type]}`,
      eventLabel: (opEvent[type] && opEvent[type][typeEvent]) || null
    });
  },
  oneHikIDLoginFail(code, text) {
    buryPoint.event({
      eventCategory: 'OneHikID登录',
      action: `OneHikID登录-HPC登录失败`,
      eventLabel: `${code}: ${text}`
    });
  },
  onehikidCantUse() {
    buryPoint.event({
      eventCategory: 'OneHikID',
      action: `OneHikID-浏览器不支持`
    });
  },
  login() {
    buryPoint.event({
      action: 'Login-使用功能',
      eventCategory: 'Login'
    });
  },
  loginDemo() {
    buryPoint.event({
      action: 'Demo-使用功能',
      eventCategory: 'Demo'
    });
  },
  adminRegisterWithAuthcode(index) {
    const op = {
      1: '认证码必填',
      2: '认证码选填'
    };
    buryPoint.event({
      action: '注册认证-使用功能',
      eventCategory: '注册认证',
      eventLabel: op[index]
    });
  },
  authenticationWithCode() {
    buryPoint.event({
      action: '账号认证-认证码认证',
      eventCategory: '账号认证'
    });
  },
  sendAuthenticationEmail() {
    buryPoint.event({
      action: '账号认证-线上认证',
      eventCategory: '账号认证'
    });
  },
  applyAuthenticationCode() {
    buryPoint.event({
      action: '获取认证码-查看获取方式',
      eventCategory: '获取认证码'
    });
  },
  getAuthcodeBySendEmail() {
    buryPoint.event({
      action: '获取认证码-发送邮件',
      eventCategory: '获取认证码'
    });
  },
  statisticShowDialog(type) {
    const op = {
      1: '公司认证信息',
      2: '公司名称',
      3: '员工职称', // 已去掉
      4: '税号'
    };
    buryPoint.event({
      action: '补充信息-出现弹窗',
      eventCategory: '补充信息',
      eventLabel: op[type]
    });
  },
  confirmAuthInfo(type) {
    const op = {
      1: '公司认证信息',
      2: '公司名称',
      3: '员工职称', // 已去掉
      4: '税号'
    };
    buryPoint.event({
      action: '补充信息-提交信息',
      eventCategory: '补充信息',
      eventLabel: op[type]
    });
  },
  requestThridLoginInfo() {
    buryPoint.event({
      action: 'Login-使用功能',
      eventCategory: '重新获取三方登录信息'
    });
  },
  register() {
    buryPoint.event({
      action: 'register-使用功能',
      eventCategory: 'register'
    });
  },
  sendEmailCode() {
    buryPoint.event({
      action: 'admin用户注册-发送验证码',
      eventCategory: 'admin用户注册'
    });
  },
  clickUnreceivedEmailCode() {
    buryPoint.event({
      action: 'admin用户注册-验证码未收到',
      eventCategory: 'admin用户注册'
    });
  },
  reSendEmailCode() {
    buryPoint.event({
      action: 'admin用户注册-重新获取验证码',
      eventCategory: 'admin用户注册'
    });
  },
  isEmailCodeCorrect(type) {
    const op = {
      1: '正确',
      2: '错误'
    };
    buryPoint.event({
      action: 'admin用户注册-验证码验证结果',
      eventCategory: 'admin用户注册',
      eventLabel: op[type]
    });
  },
  chooseSubscribe() {
    buryPoint.event({
      action: 'admin用户注册-营销活动订阅',
      eventCategory: 'admin用户注册'
    });
  },
  howToGetAuthcode(type) {
    const op = {
      1: '选填，联系海康',
      2: '选填，联系经销商',
      3: '必填，联系海康',
      4: '必填，北美和加拿大'
    };
    buryPoint.event({
      action: '注册认证-如何获取验证码',
      eventCategory: '注册认证',
      eventLabel: op[type]
    });
  },
  isAuthcodeValid(type) {
    const op = {
      1: '认证通过',
      2: '认证码无效'
    };
    buryPoint.event({
      action: '注册认证-认证结果',
      eventCategory: '注册认证',
      eventLabel: op[type]
    });
  },
  entranceToAuth(type) {
    const op = {
      1: '公司详情页-立即认证',
      2: '公司详情页-重新认证',
      3: '认证失败原因弹窗-重新认证',
      4: 'Service Market顶部-立即认证按钮',
      5: 'Service Market-Health Monitoring Package卡片-气泡提示',
      6: 'Service Market-Employee account add-on卡片-气泡提示',
      7: '运维管理-付费按钮气泡提示',
      8: '健康检测-空状态',
      9: '异常推送-空状态',
      10: '定时报表-空状态',
      11: '企业未认证提示弹窗-立即认证'
    };
    buryPoint.event({
      action: '账号认证-认证入口位置',
      eventCategory: '账号认证',
      eventLabel: op[type]
    });
  },
  codeAuth() {
    buryPoint.event({
      action: '账号认证-认证码认证弹窗',
      eventCategory: '账号认证'
    });
  },
  adminAuthDialog() {
    buryPoint.event({
      action: '账号认证-线上认证弹窗',
      eventCategory: '账号认证'
    });
  },
  getCodeByCompleteCompanyInfo() {
    buryPoint.event({
      action: '获取认证码-完成企业信息填写',
      eventCategory: '获取认证码'
    });
  },
  registrationEntrance(type) {
    const op = {
      1: '登录页右上角“注册”按钮',
      2: '产品范围-注册',
      3: '注册客户数banner-Join Now',
      4: '网页底部今天加入HPC banner-注册'
    };
    buryPoint.event({
      action: '新登录页-注册',
      eventCategory: '新登录页',
      eventLabel: op[type]
    });
  },
  keyFeaturebtn(type) {
    const op = {
      1: '云考勤详情',
      2: 'ARC集成详情',
      3: 'ARC集成案例1',
      4: 'ARC集成案例2',
      5: '开放性集成详情',
      6: '开放性集成案例'
    };
    buryPoint.event({
      action: '新登录页-keyfeature调整按钮',
      eventCategory: '新登录页',
      eventLabel: op[type]
    });
  },
  mainPageVideoClick(type) {
    const op = {
      1: 'HPC介绍',
      2: '远程配置功能介绍'
    };
    buryPoint.event({
      action: '新登录页-查看视频',
      eventCategory: '新登录页',
      eventLabel: op[type]
    });
  },
  mainPageLinkClick(type) {
    const op = {
      1: 'Link-Login',
      2: 'Link-Register',
      3: 'Link-try free demo',
      4: 'Link-Official Website',
      5: 'Support-Datasheet',
      6: 'Support-FAQ',
      7: 'Support -User Manual(Portal)',
      8: 'Support-User Manual(Mobile Client)',
      9: 'Follow us-Youtube',
      10: 'Support-Device Compatibility List'
    };
    buryPoint.event({
      action: '新登录页-网页底部按钮点击',
      eventCategory: '新登录页',
      eventLabel: op[type]
    });
  },
  authingDialogOpen() {
    buryPoint.event({
      action: '认证中状态-出现弹窗',
      eventCategory: '认证中状态'
    });
  },
  authingDialogContactOpen() {
    buryPoint.event({
      action: '认证中状态-点击联系链接',
      eventCategory: '认证中状态'
    });
  },
  getEmailJumpToHomePage() {
    buryPoint.event({
      action: '点击邮件链接-跳转进入首页',
      eventCategory: '点击邮件链接'
    });
  },
  freeGetCoBrandingBtn(type) {
    const op = {
      1: '免费领取弹窗',
      2: 'Co-branding页-banner-免费领取',
      3: '服务市场-co-branding免费领取'
    };
    buryPoint.event({
      action: 'Co-branding-免费领取-按钮点击',
      eventCategory: 'Co-branding',
      eventLabel: op[type]
    });
  },
  freeGetCobrandingDialog(type) {
    const op = {
      1: '未认证&未添加3台设备',
      2: '已认证&未添加3台设备',
      3: '未认证&已添加3台设备',
      4: '已认证&已添加3台设备'
    };
    buryPoint.event({
      action: 'Co-branding-免费领取弹窗',
      eventCategory: 'Co-branding',
      eventLabel: op[type]
    });
  },
  goAuthCoBranding() {
    buryPoint.event({
      action: 'Co-branding-去认证-按钮点击',
      eventCategory: 'Co-branding'
    });
  },
  goAddDeviceCoBranding() {
    buryPoint.event({
      action: 'Co-branding-去添加-按钮点击',
      eventCategory: 'Co-branding'
    });
  },
  clickSetPriorityPage(flag, type) {
    const op = {
      1: '优先Site页次数',
      2: '优先Home页次数',
      3: '优先Explore页次数',
      4: '点击OK',
      5: '点击菜单次数'
    };
    const op2 = {
      1: '优先页面弹窗-按钮点击',
      2: '优先提示弹窗-点击OK',
      3: '右侧菜单优先设置-点击'
    };
    buryPoint.event({
      eventCategory: '优先页面设置',
      action: op2[type],
      // '优先页面弹窗-按钮点击',
      eventLabel: op[flag]
    });
  },
  statisticsRegistrationRate(type, step, code) {
    const op1 = {
      1: 'oneHikId注册',
      2: 'hpc注册'
    };
    const op2 = {
      1: '获取邮箱验证码',
      2: '校验邮箱验证码',
      3: '校验OneHikID登录token',
      4: '补充公司信息'
    };
    buryPoint.event({
      action: `统计注册成功率-${op1[type]}`,
      eventCategory: '统计注册成功率',
      eventLabel: code ? `${op2[step]}-请求失败-${code}` : `${op2[step]}-请求成功`
    });
  },
  targetToNewHome() {
    buryPoint.event({
      eventCategory: '新登录页',
      action: '新登录页-登录直接访问EP新Home页'
    });
  },
  targetToHPC() {
    buryPoint.event({
      eventCategory: '新登录页',
      action: '新登录页-登录直接访问HPC模式'
    });
  }
};
